var OpenFromLocal, OpenFromURI;

import {
  useRef
} from 'react';

import {
  E,
  useState2
} from '@ppzp/utils.rc';

import {
  make_book
} from 'src/service/book.coffee';

import './index.styl';

export default function() {
  return E.section({
    plass: 'open'
  }, E({
    plass: 'open_wrapper'
  }, E(OpenFromLocal), E(OpenFromURI)));
};

OpenFromLocal = function() {
  var ref_input;
  ref_input = useRef();
  return E({
    plass: 'row local'
  }, E.button({
    plass: 'link',
    onClick: function() {
      if (window.FileReader) {
        return ref_input.current.click();
      } else {
        return alert('你的浏览器不支持“从本地打开”，推荐使用 Edge 或 Chrome');
      }
    }
  }, '打开本地文件'), E.input({
    ref: ref_input,
    type: 'file',
    onChange: function(evt) {
      var reader;
      reader = new FileReader();
      reader.onload = function(evt) {
        return make_book(evt.target.result);
      };
      return reader.readAsArrayBuffer(evt.target.files[0]);
    }
  }));
};

OpenFromURI = function() {
  var ref_input, state;
  ref_input = useRef();
  state = useState2('');
  return E({
    plass: 'row uri'
  }, E.button({
    plass: 'link',
    onClick: function() {
      if (state.value) {
        return make_book(state.value);
      } else {
        alert('输入下载链接先');
        return ref_input.current.focus();
      }
    }
  }, '打开网络文件'), E.input({
    ref: ref_input,
    value: state.value,
    placeholder: '输入电子书链接',
    onChange: function(evt) {
      return state.set(evt.target.value);
    },
    onKeyDown: function(evt) {
      if (evt.keyCode === 13) {
        return make_book(state.value);
      }
    }
  }));
};
